import { render, staticRenderFns } from "./FortuneWheelWinningViewModal.vue?vue&type=template&id=528cf74a&"
import script from "./FortuneWheelWinningViewModal.vue?vue&type=script&lang=js&"
export * from "./FortuneWheelWinningViewModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports